import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, memo } from 'react';
import SegmentIconsWrapper from '../wrappers/SegmentIconsWrapper';
import IconWrapper from '../wrappers/IconWrapper';
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

var createIconsComponent = function createIconsComponent(path, displayName, type) {
  var Wrapper = type === "Segment" ? SegmentIconsWrapper : IconWrapper;

  var Component = function Component(_ref, ref) {
    var children = _ref.children,
        rest = _objectWithoutProperties(_ref, _excluded);

    return _jsxs(Wrapper, _objectSpread(_objectSpread({
      ref: ref,
      "data-testid": "icon[".concat(displayName, "]")
    }, rest), {}, {
      children: [path, children]
    }));
  };

  if (false) {
    Component.displayName = displayName;
  }

  return /*#__PURE__*/memo( /*#__PURE__*/forwardRef(Component));
};

export default createIconsComponent;